export const Roles = {
    SUPERADMIN: "superadmin",
    APP_SUPERADMIN: "app_superadmin",
    APP_ADMIN: "app_admin",
    APP_ADMIN_INTERNAL: "app_admin_internal",
    APP_SUPPORT: "app_support",
    SUPPORT: "support",
    COMPANY_ADMIN: "admin",
    USER: "user"
};

export const DeveloperRegistrationStatus = {
    CONFIRMED: "CONFIRMED",
    INITIALIZING: "INITIALIZING"
};
